export function sortArticlesByDate(edges) {
  return [...edges].sort((a, b) => new Date(b.node.date) - new Date(a.node.date));
}

export function getNextArticles({ edges, currentSlug, count = 4 }) {
  const sorted = sortArticlesByDate(edges);
  const currentIndex = sorted.findIndex(({ node }) => node._sys.filename === currentSlug);

  if (currentIndex === -1) {
    return [];
  }

  const results = [];

  for (let step = 1; step < sorted.length && results.length < count; step++) {
    const { node } = sorted[(currentIndex + step) % sorted.length];

    if (!node?.title || node._sys.filename === currentSlug) {
      continue;
    }

    results.push({
      slug: node._sys.filename,
      title: node.title,
    });
  }

  return results;
}
